var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vfc-day vfc-week-number",style:({ borderRightColor: _vm.borderColor })},[_c('span',{staticClass:"vfc-span-day"},[_vm._v(_vm._s(_vm.number))])])}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-ef78b1e2","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./node_modules/vue-functional-calendar/src/components/WeekNumbers.vue
// module id = eXZy
// module chunks = 1